var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 4.00004C12.5968 4.00004 11.9998 3.40309 11.9998 2.66671C11.9998 1.93033 12.5968 1.33337 13.3332 1.33337C14.0696 1.33337 14.6665 1.93033 14.6665 2.66671C14.6665 3.40309 14.0696 4.00004 13.3332 4.00004Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66642 4.00004C1.93004 4.00004 1.33309 3.40309 1.33309 2.66671C1.33309 1.93033 1.93004 1.33337 2.66642 1.33337C3.4028 1.33337 3.99976 1.93033 3.99976 2.66671C3.99976 3.40309 3.4028 4.00004 2.66642 4.00004Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66642 9.33305C1.93004 9.33305 1.33309 8.73609 1.33309 7.99972C1.33309 7.26334 1.93004 6.66638 2.66642 6.66638C3.4028 6.66638 3.99976 7.26334 3.99976 7.99972C3.99976 8.73609 3.4028 9.33305 2.66642 9.33305Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 9.33305C12.5968 9.33305 11.9998 8.73609 11.9998 7.99972C11.9998 7.26334 12.5968 6.66638 13.3332 6.66638C14.0696 6.66638 14.6665 7.26334 14.6665 7.99972C14.6665 8.73609 14.0696 9.33305 13.3332 9.33305Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 14.6665C12.5968 14.6665 11.9998 14.0696 11.9998 13.3332C11.9998 12.5968 12.5968 11.9999 13.3332 11.9999C14.0696 11.9999 14.6665 12.5968 14.6665 13.3332C14.6665 14.0696 14.0696 14.6665 13.3332 14.6665Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 2.66638L3.99976 2.66638",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 7.99988L3.99976 7.99988",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 13.333H10.6664C9.40934 13.333 8.7808 13.333 8.39028 12.9425C7.99976 12.552 7.99976 11.9235 7.99976 10.6664L7.99976 2.66638",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.ecb42ea6f95cf6edfd1fe16f534b5241.svg";
export { ForwardRef as ReactComponent };